// src/components/HelpFab.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle, BookOpen } from 'lucide-react';

export default function HelpFab() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  // Fecha ao clicar fora
  useEffect(() => {
    function onDocClick(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  // Atalho: Shift + ?
  useEffect(() => {
    function onKey(e) {
      const shiftQMark = e.shiftKey && (e.key === '?' || (e.key === '/' && e.shiftKey));
      if (shiftQMark) {
        e.preventDefault();
        navigate('/tutorial');
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  return (
    <div ref={ref} className="fixed bottom-5 right-5 z-40">
      {/* Botão principal */}
      <button
        onClick={() => setOpen(v => !v)}
        className="w-12 h-12 rounded-full shadow-lg flex items-center justify-center
                   bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
        title="Ajuda (Shift+?)"
        aria-label="Ajuda"
      >
        <HelpCircle size={22} />
      </button>

      {/* Popover */}
      {open && (
        <div className="mt-2 w-56 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700
                        bg-white dark:bg-gray-800 overflow-hidden">
          <button
            onClick={() => { setOpen(false); navigate('/tutorial'); }}
            className="w-full px-3 py-3 flex items-center gap-2 text-left hover:bg-gray-50 dark:hover:bg-gray-700
                       text-gray-800 dark:text-gray-100"
          >
            <BookOpen size={18} className="text-blue-600" />
            <div className="flex flex-col">
              <span className="font-semibold">Abrir Tutorial</span>
              <span className="text-xs text-gray-500 dark:text-gray-400">Notas fiscais</span>
            </div>
          </button>
          {/* Espaço para futuras opções: Central de ajuda, Suporte, Atalhos etc. */}
        </div>
      )}
    </div>
  );
}
